function e(e,r=!1){if(!e)return;const t=e.slice(0,4).readUInt32LE(0);return e.slice(4,4+t).toString().replace(/^\0/,r?"":"\0")}export{e as deserializeReverse};
//# sourceMappingURL=deserializeReverse.mjs.map
